<template>
<div class="chapter">
<div class="inner_page">
<p class="image-title"><span>OFF TO THE RACES</span></p>
<p class="image-center"><span><img alt="image" class="svg" src="images/OffToTheRaces.jpg"/></span></p>
<p class="normal2"><b>Across</b></p>
<p class="hang-indent1">1.  Gardner creation</p>
<p class="hang-indent1">6.  Toss</p>
<p class="hang-indent2">11. Sixth sense; abbr.</p>
<p class="hang-indent2">14. Derby winner of 1905</p>
<p class="hang-indent2">15. Spanish queen</p>
<p class="hang-indent2">16. My _____</p>
<p class="hang-indent2">17. Cut-ups</p>
<p class="hang-indent2">18. Suggest</p>
<p class="hang-indent2">19. SM, MED, _____</p>
<p class="hang-indent2">20. Police radio call; abbr.</p>
<p class="hang-indent2">21. 1973 winner</p>
<p class="hang-indent2">24. Upper NYC thoroughfare</p>
<p class="hang-indent2">25. Sizzle</p>
<p class="hang-indent2">26. Black Sea port</p>
<p class="hang-indent2">27. Attach</p>
<p class="hang-indent2">30. Hair raiser?</p>
<p class="hang-indent2">31. Big name in insurance</p>
<p class="hang-indent2">33. Int. commerce grp.</p>
<p class="hang-indent2">35. A Winkler</p>
<p class="hang-indent2">39. Milking aid</p>
<p class="hang-indent2">40. Manhattan campus; abbr.</p>
<p class="hang-indent2">41. Harlot of Jericho</p>
<p class="hang-indent2">42. D.C. naval facility</p>
<p class="hang-indent2">43. Poetic evening</p>
<p class="hang-indent2">44. Kansas City university</p>
<p class="hang-indent2">45. U2 or ELO</p>
<p class="hang-indent2">47. Roofer</p>
<p class="hang-indent2">49. San Fernando Valley town</p>
<p class="hang-indent2">52. Pats’ old org.</p>
<p class="hang-indent2">53. Grass court org.</p>
<p class="hang-indent2">56. 1977 winner</p>
<p class="hang-indent2">59. Tire need</p>
<p class="hang-indent2">60. Stooge</p>
<p class="hang-indent2">61. Easter in Italy, e.g.</p>
<p class="hang-indent2">62. Certain manual</p>
<p class="hang-indent2">64. Ike’s WWII turf</p>
<p class="hang-indent2">65. Actor, Davis</p>
<p class="hang-indent2">66. 1935 winner</p>
<p class="hang-indent2">67. “Ask _____ …”</p>
<p class="hang-indent2">68. Scratches</p>
<p class="hang-indent2">69. Songster, Leo</p>
<p class="normal2"><b>Down</b></p>
<p class="hang-indent1">1.  Certain parrot</p>
<p class="hang-indent1">2.  Wide open</p>
<p class="hang-indent1">3.  1919 winner</p>
<p class="hang-indent1">4.  _____ Rosebud, 1914 Derby winner</p>
<p class="hang-indent1">5.  Stack role</p>
<p class="hang-indent1">6.  Adjective for 21-Across, et al.</p>
<p class="hang-indent1">7.  A Winkler</p>
<p class="hang-indent1">8.  Overrun with</p>
<p class="hang-indent1">9.  _____ many; over the top</p>
<p class="hang-indent2">10. 1937 winner</p>
<p class="hang-indent2">11. Winning jockey, 1931 Preakness</p>
<p class="hang-indent2">12. Long tales</p>
<p class="hang-indent2">13. Michelangelo masterpiece</p>
<p class="hang-indent2">22. Little lizard</p>
<p class="hang-indent2">23. Try it again</p>
<p class="hang-indent2">28. Circling</p>
<p class="hang-indent2">29. 1930 winner</p>
<p class="hang-indent2">30. 1943 winner</p>
<p class="hang-indent2">31. Tempe campus; abbr.</p>
<p class="hang-indent2">32. UFO crew</p>
<p class="hang-indent2">34. Lanyard</p>
<p class="hang-indent2">36. 1941 winner</p>
<p class="hang-indent2">37. Baron tack-on</p>
<p class="hang-indent2">38. Hoopster’s org.</p>
<p class="hang-indent2">46. Even so</p>
<p class="hang-indent2">48. Chill</p>
<p class="hang-indent2">49. City on the Ruhr</p>
<p class="hang-indent2">50. “Cool!”</p>
<p class="hang-indent2">51. 1949 Preakness winner</p>
<p class="hang-indent2">52. Spite in Spinazzola</p>
<p class="hang-indent2">54. Church offering</p>
<p class="hang-indent2">55. Like the crowd at the track</p>
<p class="hang-indent2">57. Old gas sign</p>
<p class="hang-indent2">58. “_____ Afraid of Virginia Woolf?”</p>
<p class="hang-indent2">63. Tumor; suffix</p>
<p class="center"><span>To download a PDF of this puzzle, please visit <a href="http://www.openroadmedia.com/nero-blanc-crosswords" target="_blank">openroadmedia.com/nero-blanc-crosswords</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter003.vue?1a835a96